import useTranslation from '@/utils/hooks/translation/useTranslation';

import Button from '@/components/base/Button';
import Modal from '@/components/base/Modal';

type FooterSinglePostProps = {
    toggle: () => void;
    onDelete: (deleteCrossPosts?: boolean) => void;
    isDeletingSinglePost: boolean;
};

export const FooterSinglePost = ({
    toggle,
    onDelete,
    isDeletingSinglePost
}: FooterSinglePostProps) => {
    const { t } = useTranslation('scheduler');
    return (
        <Modal.Footer
            className="flex flex-col items-center justify-between space-y-3 px-5 pb-12 pt-8 xs:flex-row xs:space-x-3 xs:space-y-0 sm:px-12"
            divider={false}>
            <Button variant="secondary" className="w-full" onClick={toggle}>
                {t('commons:no')}
            </Button>
            <Button isLoading={isDeletingSinglePost} onClick={() => onDelete()} className="w-full">
                {t('commons:yes')}
            </Button>
        </Modal.Footer>
    );
};
